import Vue from 'vue';
import Bugsnag from 'bugsnag-js';
import BugsnagVue from 'bugsnag-vue';

Bugsnag.apiKey = api.env.BUGSNAG_API_KEY;
Bugsnag.releaseStage = api.env.APP_ENV;
let stages = api.env.BUGSNAG_NOTIFY_RELEASE_STAGES;
Bugsnag.notifyReleaseStages = stages.split(',');

const bugsnagClient = Bugsnag({
    apiKey: api.env.BUGSNAG_API_KEY,
    releaseStage: api.env.APP_ENV,
});

bugsnagClient.use(BugsnagVue(Vue));
